import { CASCO, KGFB } from '../../../modules/Const';

export default class KgfbTarifa {
    static getFedezetlensegiDij(dijak) {
        return Math.max(...dijak.map((a) => Number(a.mabisz_dij)));
    }

    static getRecalculateDataByBiztIds(
        biztIds,
        recalc = false,
        modozatok = [],
        selectedRecalculate = false,
        context,
        firstCalculation = false,
    ) {
        const recalcObj = {
            recalculate: recalc,
            selectedRecalculate,
            tarifaData: {
                id: context.state.id,
                tarifa_id: context.state.tarifaData.tarifa_id,
            },
        };

        const kellGfb = modozatok.includes(KGFB);
        const kellCasco = modozatok.includes(CASCO);

        if (kellGfb) {
            recalcObj.gfb = {
                biztositok: biztIds,
                payment: {
                    ajanl_fizmod_type: context.state.tarifaData.ajanl_fizmod_type,
                    ajanl_fizutem_type: context.state.tarifaData.ajanl_fizutem_type,
                },
                kedvezmenyek: {},
                additions: {},
            };
        } else {
            recalcObj.gfb = {
                biztositok: [],
                payment: {
                    ajanl_fizmod_type: context.state.tarifaData.ajanl_fizmod_type,
                    ajanl_fizutem_type: context.state.tarifaData.ajanl_fizutem_type,
                },
                kedvezmenyek: {},
                additions: {},
            };
        }

        if (kellCasco) {
            recalcObj.casco = {
                biztositok: biztIds,
                payment: {
                    casco_fizutem: context.state.tarifaData.casco_fizutem,
                    casco_fizmod: context.state.tarifaData.casco_fizmod,
                    casco_onresz_ft: context.state.tarifaData.casco_onresz_ft,
                    casco_onresz_szaz: context.state.tarifaData.casco_onresz_szaz,
                },
                kedvezmenyek: {},
                additions: {},
                products: {},
            };

            if (firstCalculation) {
                recalcObj.casco.first_calculation = true;
            }
        } else {
            recalcObj.casco = {
                biztositok: [],
                payment: {
                    casco_fizutem: context.state.tarifaData.casco_fizutem,
                    casco_fizmod: context.state.tarifaData.casco_fizmod,
                    casco_onresz_ft: context.state.tarifaData.casco_onresz_ft,
                    casco_onresz_szaz: context.state.tarifaData.casco_onresz_szaz,
                },
                kedvezmenyek: {},
                additions: {},
                products: {},
            };
        }

        biztIds.forEach((biztositoid) => {
            if (kellGfb) {
                recalcObj.gfb.kedvezmenyek[biztositoid] = {
                    biztositomezo: context.state.kedvezmenyekbiztosito[biztositoid],
                    alaptabla: context.state.kedvezmenyekalaptabla[biztositoid],
                };
                recalcObj.gfb.additions[biztositoid] = context.state.additions[biztositoid];
            }

            if (kellCasco) {
                recalcObj.casco.kedvezmenyek[biztositoid] = context.state.cascokedvezmenyek[biztositoid];
                recalcObj.casco.additions[biztositoid] = context.state.cascoadditions[biztositoid];
                recalcObj.casco.products[biztositoid] = context.state.cascoproducts[biztositoid];
            }
        });

        return recalcObj;
    }

    static getTarifaData(context) {
        return {
            id: context.state.id,
            tarifa_id: context.state.tarifaData.tarifa_id,
            ajanl_fizmod_type: context.state.tarifaData.ajanl_fizmod_type,
            ajanl_fizutem_type: context.state.tarifaData.ajanl_fizutem_type,
        };
    }

    static getProcessedDijak(response, context) {
        const dijak = [...context.state.dijak];

        if (response.kgfb) {
            response.kgfb.tarifaDijak.forEach((kgfbDij) => {
                const index = KgfbTarifa.dijakHasBizt(dijak, kgfbDij.biztositoid);

                if (index > -1) {
                    dijak[index].kgfb = kgfbDij;
                } else {
                    dijak.push({
                        biztositoid: kgfbDij.biztositoid,
                        calculation_id: kgfbDij.calculation_id,
                        kgfb: kgfbDij,
                    });
                }
            });
        }

        if (response.casco) {
            response.casco.tarifaDijak.forEach((cascoDij) => {
                const index = KgfbTarifa.dijakHasBizt(dijak, cascoDij.biztositoid);

                if (index > -1) {
                    dijak[index].casco = cascoDij;
                } else {
                    dijak.push({
                        biztositoid: cascoDij.biztositoid,
                        calculation_id: cascoDij.calculation_id,
                        casco: cascoDij,
                    });
                }
            });
        }

        for (let i = 0; i < dijak.length; i += 1) {
            if (!dijak[i].kgfb) {
                // console.log('itt nincs gfb hozzáadunk', i)
                dijak[i].kgfb = {
                    yearly_fee: 0,
                    errors: { errors: [] },
                    warnings: { warnings: [] },
                    docs: [],
                    discounts: [],
                };
            }

            if (!dijak[i].casco) {
                dijak[i].casco = {
                    yearly_fee: 0,
                    errors: { errors: [] },
                    warnings: { warnings: [] },
                    docs: [],
                    discounts: [],
                };
            }
        }
        // console.log(dijak)
        return dijak;
    }

    static dijakHasBizt(dijak, biztId) {
        let index = -1;
        for (let i = 0; i < dijak.length; i += 1) {
            if (dijak[i].biztositoid === biztId) {
                index = i;
            }
        }
        return index;
    }

    static getProcessedKgfbKedvezmenyekAdditions(response) {
        const kedvezmenyekalaptabla = {};
        const kedvezmenyekbiztosito = {};
        const cascokedvzemenyek = {};
        const additions = {};
        const cascoproducts = {};
        const cascoadditions = {};

        if (response.kgfb) {
            response.kgfb.tarifaDijak.forEach((bizt) => {
                kedvezmenyekalaptabla[bizt.biztositoid] = {};
                kedvezmenyekbiztosito[bizt.biztositoid] = {};
                additions[bizt.biztositoid] = {};

                if (!!bizt.tarifa_properties && !!bizt.tarifa_properties.discounts) {
                    bizt.tarifa_properties.discounts.forEach((kedvezmeny) => {
                        let finalVal;
                        if (kedvezmeny.value !== null) {
                            finalVal = kedvezmeny.value;
                        } else if (typeof kedvezmeny.defaultValue !== 'undefined') {
                            finalVal = kedvezmeny.defaultValue;
                        } else {
                            finalVal = null;
                        }

                        if (kedvezmeny.place === 'biztositomezo') {
                            kedvezmenyekbiztosito[bizt.biztositoid][kedvezmeny.name] = finalVal;
                        } else {
                            kedvezmenyekalaptabla[bizt.biztositoid][kedvezmeny.name] = finalVal;
                        }
                    });
                }

                if (!!bizt.tarifa_properties && !!bizt.tarifa_properties.additionals) {
                    bizt.tarifa_properties.additionals.forEach((addition) => {
                        if (addition.value !== null) {
                            additions[bizt.biztositoid][addition.name] = addition.value;
                        } else if (typeof addition.defaultValue !== 'undefined') {
                            additions[bizt.biztositoid][addition.name] = addition.defaultValue;
                        } else {
                            additions[bizt.biztositoid][addition.name] = null;
                        }
                    });
                }
            });
        }

        if (response.casco) {
            response.casco.tarifaDijak.forEach((bizt) => {
                cascokedvzemenyek[bizt.biztositoid] = {};
                cascoadditions[bizt.biztositoid] = {};
                cascoproducts[bizt.biztositoid] = {};

                if (!!bizt.tarifa_properties && bizt.tarifa_properties.discounts) {
                    bizt.tarifa_properties.discounts.forEach((kedvezmeny) => {
                        if (kedvezmeny.value !== null) {
                            cascokedvzemenyek[bizt.biztositoid][kedvezmeny.name] = kedvezmeny.value;
                        } else if (typeof kedvezmeny.defaultValue !== 'undefined') {
                            cascokedvzemenyek[bizt.biztositoid][kedvezmeny.name] = kedvezmeny.defaultValue;
                        } else {
                            cascokedvzemenyek[bizt.biztositoid][kedvezmeny.name] = null;
                        }
                    });
                }

                if (!!bizt.tarifa_properties && !!bizt.tarifa_properties.additionals) {
                    bizt.tarifa_properties.additionals.forEach((addition) => {
                        if (addition.value !== null) {
                            cascoadditions[bizt.biztositoid][addition.name] = addition.value;
                        } else if (typeof addition.defaultValue !== 'undefined') {
                            cascoadditions[bizt.biztositoid][addition.name] = addition.defaultValue;
                        } else {
                            cascoadditions[bizt.biztositoid][addition.name] = null;
                        }
                    });
                }

                if (!!bizt.tarifa_properties && !!bizt.tarifa_properties.products) {
                    bizt.tarifa_properties.products.forEach((product) => {
                        if (product.value !== null) {
                            cascoproducts[bizt.biztositoid][product.name] = product.value;
                        } else if (typeof product.defaultValue !== 'undefined') {
                            cascoproducts[bizt.biztositoid][product.name] = product.defaultValue;
                        } else {
                            cascoproducts[bizt.biztositoid][product.name] = null;
                        }
                    });
                }
            });
        }

        return {
            kgfb: {
                discounts: {
                    alaptabla: kedvezmenyekalaptabla,
                    biztosito: kedvezmenyekbiztosito,
                },
                additions,
            },
            casco: {
                discounts: cascokedvzemenyek,
                additions: cascoadditions,
                products: cascoproducts,
            },

        };
    }

    static calculationResponseHandler(response, context) {
        context.commit('setProp', {
            path: 'dijak',
            value: KgfbTarifa.getProcessedDijak(response.data.dijak, context),
        });
        KgfbTarifa.setAssistance(response.data.dijak?.assistance, context);
        if (response.data.dijak?.kgfb?.statusz) {
            context.commit('setStatusz', response.data.dijak.kgfb.statusz);
        }
        if (response.data.dijak?.casco?.statusz) {
            context.commit('setStatusz', response.data.dijak.casco.statusz);
        }
        const kedvezmenyek = KgfbTarifa.getProcessedKgfbKedvezmenyekAdditions(response.data.dijak);
        context.dispatch('setKedvezmenyekAdditions', kedvezmenyek);
        if (response.data.dijak.kgfb) {
            context.commit('setProp', {
                path: 'indexDij',
                value: response.data.dijak.kgfb.indexdij,
            });
            context.commit('setFedezetlensegiDij',
                KgfbTarifa.getFedezetlensegiDij(response.data.dijak.kgfb.tarifaDijak));
        }
        context.commit('stopLoading');
    }

    static setAssistance(response, context) {
        context.commit('setProp', { path: 'assistance', value: response });
        context.commit('setProp', { path: 'valasztottAssistanceDijAdatok', value: null });

        if (!response) return;
        Object.keys(response).some((key) => {
            const selectedPackage = response[key].dijcsomagok.find((pkg) => pkg.selected);
            if (!selectedPackage) return false;

            context.commit('setProp', {
                path: 'valasztottAssistanceDijAdatok',
                value: { biztositoId: +key, ...selectedPackage },
            });
            return true;
        });
    }
}
